import BaseComponent from "./BaseComponent";
import MathUtil from "../utils/MathUtil";
import C_GameEvent from "../const/C_GameEvent";
import FriendlyBot from "./FriendlyBot";

class BotsController extends BaseComponent
{
    constructor()
    {
        super();

        this.botsInGame = 0;
        this.bots =
        {
            1:
            {
                joinDelay: this.scheduleBotJoinTime(),
                isActive: false,
                bot: null
            },
            2:
            {
                joinDelay: this.scheduleBotJoinTime(),
                isActive: false,
                bot: null
            }
        };

        // this.usedRooms = {0: false, 1: false, 2: false};
        // this.usedRooms[this.app.model.getRoomId()] = true;

        this.usedBadges = {0: false, 1: false, 2: false, 3: false, 4: false, 5: false};

        this.room = this.app.model.getRoomId();
    }


    init()
    {
        this.botsInGame = MathUtil.getRandomInt(0, 2);
        for (let i=1; i<=this.botsInGame; i++)
        {
            this.spawnBot(i);
        }
    }


    spawnBot(pos)
    {
        let botName = this.generateRandomName();
        let badgeId = this.getUnusedBadgeId();
        let bot = this.app.eFactory.getBot(botName, pos, badgeId);
        bot.lifeTime = this.getBotLifetime();
        this.bots[pos].bot = bot;
        this.bots[pos].isActive = true;

        let fb = bot.getComponent(FriendlyBot);
        // enter room
        // let botRoomId = this.getUnusedRoomIds();
        // this.usedRooms[botRoomId] = true;

        fb.setBotRoom(this.room);

        this.entitySystem.addEntity(bot);

        console.log("Bot " + botName + " entered on position: " + pos + " with " + fb.botBalance + " coins");
        //this.app.dispatcher.emit(C_GameEvent.BOT_JOINED, botName, pos);
    }


    removeBot(pos)
    {
        this.bots[pos].bot.queueForRemoval = true;
        this.bots[pos].joinDelay = this.scheduleBotJoinTime();
        this.bots[pos].isActive = false;

        // empty badge
        let fb = this.bots[pos].bot.getComponent(FriendlyBot);
        let badgeId = fb.getBotRoom();
        this.usedBadges[badgeId] = false;

        // empty room
        // let fb = this.bots[pos].bot.getComponent(FriendlyBot);
        // let botRoomId = fb.getBotRoom();
        // this.usedRooms[botRoomId] = false;

        //this.app.dispatcher.emit(C_GameEvent.BOT_EXITED, pos);
    }


    // getUnusedRoomIds()
    // {
    //     let emptyRooms = [];
    //     for (let room in this.usedRooms)
    //     {
    //         if (this.usedRooms[room] == false)
    //         {
    //             emptyRooms.push(room);
    //         }
    //     }
    //     let randomRoom = MathUtil.getRandomInt(0, emptyRooms.length - 1);
    //
    //     return emptyRooms[randomRoom];
    // }


    getUnusedBadgeId()
    {
        let freeBadges = [];
        for (let badge in this.usedBadges)
        {
            if (this.usedBadges[badge] == false)
            {
                freeBadges.push(badge);
            }
        }
        let randomBadge = MathUtil.getRandomInt(0, freeBadges.length - 1);

        return freeBadges[randomBadge];
    }


    getBotLifetime()
    {
        return MathUtil.getRandomInt(240, 480); // num/4 in seconds (40 = 10 seconds)
    }


    scheduleBotJoinTime()
    {
        return MathUtil.getRandomInt(240, 480);
    }


    postPhysicsUpdate(delta)
    {

        for (let i in this.bots)
        {
            let bot = this.bots[i].bot;
            let isActive = this.bots[i].isActive;
            let joinDelay = this.bots[i].joinDelay;

            if (bot && isActive)
            {
                if (bot.lifeTime < 0)
                {
                    this.removeBot(i);
                }
            }

            if (!isActive)
            {
                this.bots[i].joinDelay -= delta;

                if(joinDelay < 0)
                {
                    this.spawnBot(i);
                }
            }
        }
    }


    getBotName()
    {
        let prefixName =
        [
            "Snicker", "Buffalo", "Gross", "Bubble", "Sheep",
            "Corset", "Toilet", "Lizard", "Waffle", "Kumquat", "Burger", "Chimp", "Liver",
            "Gorilla", "Rhino", "Emu", "Pizza", "Toad", "Gerbil", "Pickle", "Tofu",
            "Chicken", "Potato", "Hamster", "Lemur", "Vermin","Waffer", "Lilly",
            "Rugrat","Sand", "Fuzzy","Kitty",
            "Puppy", "Snuggles","Rubber", "Stinky", "Lulu", "Lala", "Sparkle", "Glitter",
            "Silver", "Golden", "Rainbow", "Cloud", "Rain", "Stormy", "Wink", "Sugar",
            "Twinkle", "Star", "Halo", "Angel"
        ];

        return prefixName[MathUtil.getRandomInt(0, prefixName.length)];
    }


    generateRandomName()
    {
        let postfix;

        let N = MathUtil.getRandomInt(0, 4); //
        let s = "0123456789";
        postfix = Array(N).join().split(',').map(function() { return s.charAt(Math.floor(Math.random() * s.length)); }).join('');

        let name = this.getBotName() + postfix;

        return name;
    }
}

export default BotsController;